import { categoriesUrl } from "../resources";
import getRequest from '../common/getRequest.js'

async function getCategoriesByRestaurant(restaurantId, token) {

    let url = `${categoriesUrl}/getbyrestaurant/${restaurantId}`;

    let data;

    await getRequest.getDataWithToken(url, token)
                .then(res => {
                    data = res.categories
                });
    return data;
}

export default {
    getCategoriesByRestaurant
}